import { config } from '@/config';
import { AxlePosition } from '@/generated/GeneratedApiTypes';

export const AXLE_SET = [
    AxlePosition.FRONT_AXLE,
    AxlePosition.REAR_AXLE_1,
    AxlePosition.REAR_AXLE_2,
    AxlePosition.REAR_AXLE_3,
    AxlePosition.REAR_AXLE_4,
    AxlePosition.REAR_AXLE_5,
    AxlePosition.REAR_AXLE_6,
    AxlePosition.REAR_AXLE_7,
    AxlePosition.REAR_AXLE_8,
    AxlePosition.REAR_AXLE_9,
    AxlePosition.REAR_AXLE_10,
    AxlePosition.REAR_AXLE_11,
    AxlePosition.REAR_AXLE_12,
    AxlePosition.RESERVE_WHEELS,
];

export const getDetailViewHrefFor = (assetId: string) =>
    `${config.parentFrontendOrigin}/maintenance/detailview/${assetId}`;

export const axePositionToAxleNumber = (axlePosition?: AxlePosition): number | undefined => {
    if (!axlePosition) {
        return undefined;
    }
    const axleIndex = AXLE_SET.indexOf(axlePosition);

    if (axleIndex === -1) {
        return undefined;
    }
    return axleIndex + 1;
};
